<template>
	<div :class="`grid grid-cols-1 md:grid-cols-2 ${tight ? '2xl:grid-cols-3' : 'lg:grid-cols-3'} gap-4`">
		<slot/>
	</div>
</template>
<script setup lang="ts">
import {defineProps} from 'vue'

defineProps<{
	tight?:boolean,
}>()
</script>